import { Policy } from "../Policy";
import { ResponseBase } from "../base/ResponseBase";

export class JSONAPIResponse extends ResponseBase {
    Json?: any;
}
